import React from 'react';
import { Heart, Shield, Award, Users } from 'lucide-react';

const About = () => {
  const values = [
    {
      icon: Heart,
      title: 'Patient-Centered',
      description: 'Your health goals and preferences guide every decision we make together.'
    },
    {
      icon: Shield,
      title: 'Preventative Focus',
      description: 'We believe in preventing illness, not just treating it when it occurs.'
    },
    {
      icon: Award,
      title: 'Excellence',
      description: 'The highest standards of medical care delivered with personal attention.'
    },
    {
      icon: Users,
      title: 'Accessibility',
      description: 'Direct access to your provider when you need it, not weeks later.'
    }
  ];

  return (
    <section id="about" className="section-padding bg-[#fffef8]">
      <div className="container-custom">
        {/* Section header */}
        <div className="max-w-3xl mb-20">
          <div className="gold-accent mb-6"></div>
          <h2 className="font-serif text-3xl md:text-4xl text-[#2d2d2d] mb-6">
            A Different Kind of Practice
          </h2>
          <p className="text-[#5a5a5a] text-lg leading-relaxed">
            At Exquisite Concierge Medicine, we've returned to the roots of medicine—where 
            our providers know their patients deeply and have the time to provide truly 
            comprehensive care. We limit our practice to ensure every patient receives 
            the exceptional attention they deserve.
          </p>
        </div>

        {/* Content - Full width */}
        <div className="max-w-4xl">
          <h3 className="font-serif text-2xl text-[#2d2d2d] mb-6">
            Why Concierge Medicine?
          </h3>
          <p className="text-[#5a5a5a] leading-relaxed mb-6">
            Traditional primary care has become increasingly rushed and impersonal. 
            Physicians are often forced to see 25-30 patients per day, leaving little 
            time for meaningful conversations about your health.
          </p>
          <p className="text-[#5a5a5a] leading-relaxed mb-8">
            Our concierge model limits our practice to approximately 300 patients, 
            compared to 2,000+ in a typical practice. This allows us to spend 
            60-90 minutes with you during appointments, answer your calls personally, 
            and coordinate your care with the attention to detail it deserves.
          </p>

          {/* Values grid */}
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {values.map((value, index) => (
              <div key={index} className="flex items-start gap-4">
                <div className="flex-shrink-0 w-10 h-10 bg-[#f8f7f2] flex items-center justify-center">
                  <value.icon size={20} className="text-[#c9a962]" />
                </div>
                <div>
                  <h4 className="font-medium text-[#2d2d2d] mb-1">{value.title}</h4>
                  <p className="text-sm text-[#8a8a8a]">{value.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
